import React from "react";
import filterStyles from "../list/Filters.module.css";
// @ts-ignore
import RawFormattedMessage from "./RawFormattedMessage";
import { List } from "../../types/List";

interface NumberOfRecordsProps {
  disableRecordCount?: boolean;
  recordCount: number;
  section: List;
}

export default function NumberOfRecordsWrapper(props: NumberOfRecordsProps) {
  if (props.disableRecordCount === true) {
    return null;
  }
  return (
    <NumberOfRecords>
      <RawFormattedMessage
        values={{
          number: props.recordCount,
        }}
        id={`${props.section}.record-count`}
      />
    </NumberOfRecords>
  );
}

export function NumberOfRecords({ children }: { children: React.ReactNode }) {
  return <p className={filterStyles.recordNumber}>{children}</p>;
}
